import type { Ref } from "vue";
import type { Requests } from "../common/request.common";
import type { CustomerComplaintResponseTypes } from "../common/response.common";
import { asUpdateHook, get, post, postEmpty } from "./common";

export const customerComplaint = {
    record(data: typeof Requests.CustomerComplaint.Record.Input) {
        return post<typeof data, CustomerComplaintResponseTypes.Record>(
            `/customer-complaint/record`,
            data,
        );
    },
    create(data: typeof Requests.CustomerComplaint.Create.Input) {
        return post<typeof data>("/customer-complaint/create", data);
    },
    obtain(id: string) {
        return get<CustomerComplaintResponseTypes.Obtain>(`/customer-complaint/obtain/${id}`);
    },
    complaintSetup(id: string) {
        return postEmpty(`/customer-complaint/complaint-setup/${id}`);
    },
    complaintCreate(id: string, data: typeof Requests.CustomerComplaint.ComplaintCreate.Input) {
        return post<typeof data>(`/customer-complaint/complaint-create/${id}`, data);
    },
    complaintDispatch(id: string) {
        return postEmpty(`/customer-complaint/complaint-dispatch/${id}`);
    },
    provisionCreate(id: string, data: typeof Requests.CustomerComplaint.ProvisionCreate.Input) {
        return post<typeof data>(`/customer-complaint/provision-create/${id}`, data);
    },
    provisionCancel(id: string, data: typeof Requests.CustomerComplaint.ProvisionCancel.Input) {
        return post<typeof data>(`/customer-complaint/provision-cancel/${id}`, data);
    },
    complaintFinish(id: string, data: typeof Requests.CustomerComplaint.ComplaintFinish.Input) {
        return post<typeof data>(`/customer-complaint/complaint-finish/${id}`, data);
    },
    complaintReport(id: string, data: typeof Requests.CustomerComplaint.ComplaintReport.Input) {
        return post<typeof data>(`/customer-complaint/complaint-report/${id}`, data);
    },
    provisionFinalize(id: string, data: typeof Requests.CustomerComplaint.ProvisionFinalize.Input) {
        return post<typeof data>(`/customer-complaint/provision-finalize/${id}`, data);
    },
    finalize(id: string) {
        return postEmpty(`/customer-complaint/finalize/${id}`);
    },
    cancel(id: string) {
        return postEmpty(`/customer-complaint/cancel/${id}`);
    },
    formHooks: {
        update(id: string, isLoading?: Ref<boolean>) {
            return async (data: typeof Requests.CustomerComplaint.Update.Input) => {
                return await asUpdateHook(
                    post<typeof data>(`/customer-complaint/update/${id}`, data),
                    isLoading,
                );
            };
        },
    },
};
